import React, { useCallback, useContext, useEffect, useState } from "react";
import { getMISData } from "../services/mis";
import { useSession } from "./SessionProvider";

const HomeContext = React.createContext({
    homeRecords: [],
    filter: null,
    getHomeRecords: () => [],
    updateFilter: () => { }
});

export const HomeProvider = ({ children }) => {
    const { user } = useSession();
    const [homeRecords, sethomeRecords] = useState([]);
    const [filter, setFilter] = useState({
        year: "",
        month: ""
    });

    const getHomeRecords = useCallback(async (filter) => {
        try {
            const inputFilter = filter || {};
            const homeData = await getMISData(inputFilter);

            sethomeRecords(homeData.data);
        } catch (e) {
            console.log(e.message);
        }
    }, []);

    function updateFilter(filter) {
        setFilter(filter);
    }

    useEffect(() => {
        if (filter && user?.id) {
            getHomeRecords(filter);
        }
    }, [getHomeRecords, filter, user]);

    return (<HomeContext.Provider value={{
        getHomeRecords,
        updateFilter,
        homeRecords,
        filter
    }}>
        {children}
    </HomeContext.Provider>)
}

export function useHome() {
    const homeContext = useContext(HomeContext);

    return homeContext;
}